<template>
  <div>
    Payment
  </div>
</template>

<script>

export default {
  name: '',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
</style>